import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { Button } from '../../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from '../ModalComponents';
import {
  useFilterLoadingAllowedGateOutMutation,
  useLoadingAllowedGateOutMutation,
} from '../../../hooks';
import { enqueueSnackbar } from '../../snackbar';
import { MESSAGES } from '../../../const';
import { i18n } from '../../../i18n';

interface GateLoadModalType {
  data: { id: string; number: string }[];
  isGateOutFilter: boolean;
  submitClick: () => void;
  open: () => void;
}

export const gateLoadModal: GateLoadModalType = {
  data: [],
  isGateOutFilter: false,
  submitClick: () => null,
  open: () => null,
};

export const GateLoadModal = () => {
  const gateOutLoadMutation = useLoadingAllowedGateOutMutation();
  const filterGateOutLoadMutation = useFilterLoadingAllowedGateOutMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    gateLoadModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    const mutateOptions = {
      onSuccess: () => {
        handleOnClose();
        enqueueSnackbar(MESSAGES.GATE_OUT.SUCCESS.LOADING_ALLOWED, 'success');
        gateLoadModal.submitClick();
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.GATE_OUT.ERROR.NOT_EDITED, 'error');
      },
    };

    if (gateLoadModal.isGateOutFilter) {
      filterGateOutLoadMutation.mutate(gateLoadModal.data[0].id, mutateOptions);
      return;
    }

    gateOutLoadMutation.mutate(
      gateLoadModal.data.map((item) => ({
        id: item.id,
      })),
      mutateOptions,
    );
  };

  return (
    <ModalBase id={'gate-load-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.gateLoadingAllowedTitle')}
        </Typography>
        {!gateLoadModal.isGateOutFilter &&
          gateLoadModal.data.map((item, i) => (
            <Typography key={i} variant={'textM'}>
              {item.number}
            </Typography>
          ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
